module.exports = __webpack_public_path__ + "img/support-cat_ce9d2b6.webp";